module.exports = __webpack_public_path__ + "fonts/AvenirBook.ba4cc0a.ttf";